<template>
    <div class="aboutus-page">
        <page-hero title="Φιλοσοφία" eyebrow="The League" compact />
        <div class="cl-page">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-card class="cl-card cl-card--light cl-reading">
                            <span style="text-align: justify;" v-html="philosophy.content" />
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import configService from '@/services/config'
    export default {
        components: { PageHero },
        data() {
            return {
                philosophy: null
            }
        },
        created() {
            this.getPhilosophy()
        },
        methods: {
            getPhilosophy() {
                configService.getConfigField('philosophy').then(resp => {
                    this.philosophy = resp.data
                })
            }
        }
    }
</script>
